import {
    FETCHED_REDIRECT,
    FETCHED_REDIRECTS,
    CREATED_REDIRECT,
    UPDATED_REDIRECT,
    DELETED_REDIRECT,
    FETCHED_STATUSES,
    ADD_BULK_REDIRECTS_DOCUMENT,
    DELETE_BULK_REDIRECTS_DOCUMENT,
    GET_BULK_UPLOAD_ERRORS,
    BULK_REDIRECTS_UPLOADED
} from './types';

export function fetchedRedirects(data, totalPages) {
    return {
        type: FETCHED_REDIRECTS,
        payload: {
            data: data,
            totalPages: totalPages
        }
    }
}

export function fetchedStatuses(statuses) {
    return {
        type: FETCHED_STATUSES,
        statuses
    }
}

export function fetchedRedirect(redirect) {
    return {
        type: FETCHED_REDIRECT,
        redirect
    };
}

export function createdRedirect(response) {
    return {
        type: CREATED_REDIRECT,
    }
}

export function updatedRedirect(redirect) {
    return {
        type: UPDATED_REDIRECT,
        redirect
    }
}

export function deletedRedirect(redirect) {
    return {
        type: DELETED_REDIRECT,
        redirect
    }
}

export function addBulkRedirectsDocument(document) {
    return {
        type: ADD_BULK_REDIRECTS_DOCUMENT,
        payload: {
            document: document,
            touched: true,
        }
    }
}

export function deleteBulkRedirectsDocument() {
    return {
        type: DELETE_BULK_REDIRECTS_DOCUMENT
    }
}

export function getBulkUploadErrors(bulkUploadErrors) {
    return {
        type: GET_BULK_UPLOAD_ERRORS,
        bulkUploadErrors
    }
}

export function bulkRedirectsUploaded() {
    return {
        type: BULK_REDIRECTS_UPLOADED,
    }
}


// WEBPACK FOOTER //
// ./src/containers/redirects/actions.js